module.exports = {
    'gifting.store': 'customers/gifts',
    'gifting.prices.index': 'gifts/prices',
    'gifting.delivery-dates': 'gifts/delivery-dates',
    'gifting.incomplete.create': 'user/$1/incomplete-giftings',
    'gifting.incomplete.update': 'user/$1/incomplete-giftings/$2',
};
